var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#18A0B1;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150.3,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aa8d72f3-e91d-4668-864f-f6ccd32ab5ee"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f48437ee-df2e-4d1f-8155-a51b945f34ec"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb56a67f-1a1b-4fcb-afaf-5bdfb7c20b92"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 233.5,
    cy: 66.8,
    r: 17.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.8,180.2c-16.3-27.7-7.1-63.4,20.6-79.7c18.2-10.7,40.9-10.7,59.1,0l13.9-13.9l-0.7-0.6 C157,62.4,108.9,72.3,85.4,108c-17.2,26.2-17,60.1,0.5,86.1L99.8,180.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.3,121.2c16.3,27.7,7.1,63.4-20.6,79.7c-18.2,10.7-40.9,10.7-59.1,0l-13.9,13.9 c35.4,24,83.5,14.8,107.6-20.6c17.8-26.3,17.8-60.7,0-87L200.3,121.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 66.5,
    cy: 233.8,
    r: 17.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcx);
export default __webpack_public_path__ + "static/media/ICX.13103b60573738d25142e2e057ee1fef.svg";
export { ForwardRef as ReactComponent };